import { ShieldCheck, MessageCircle, Compass, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Superhost Verified",
    desc: "All six listings hold top-tier guest satisfaction metrics and verified host integrity on Airbnb.",
  },
  {
    icon: MessageCircle,
    title: "Direct Concierge",
    desc: "Skip platform friction. Instant, personal communication with our local villa concierges on WhatsApp.",
  },
  {
    icon: Compass,
    title: "Prime Locations",
    desc: "Carefully selected private plots across Canggu's oceanfront lanes and Seminyak's boutique enclaves.",
  },
  {
    icon: Sparkles,
    title: "Bespoke Services",
    desc: "Private chefs, airport transfers, wellness therapists, and daily housekeeping arranged effortlessly.",
  },
];

export const WhyUs = () => (
  <section id="why-us" className="py-24 sm:py-32 lg:py-40" data-testid="why-us-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-5 flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.3em] text-stone-500">
          <span className="h-px w-10 bg-gold" /> Why BALIBIGVILLAS
        </p>
        <h2 className="max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          The <span className="italic text-gold">Distinction</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-px border border-stone-900/10 bg-stone-900/10 sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1} className="h-full">
            <div
              data-testid={`why-us-pillar-${i}`}
              className="group flex h-full flex-col bg-ivory p-8 transition-colors duration-700 hover:bg-ink sm:p-10"
            >
              <span className="font-serif text-sm italic text-gold">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p.icon
                size={28}
                strokeWidth={1.2}
                className="mt-8 text-gold-dark transition-colors duration-700 group-hover:text-gold"
              />
              <h3 className="mt-5 font-serif text-2xl font-light text-ink transition-colors duration-700 group-hover:text-ivory">
                {p.title}
              </h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-stone-600 transition-colors duration-700 group-hover:text-ivory/60">
                {p.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
